<!--FastBI产品-->
<template>
  <div class="home-main service clearfix">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">结算价格</span>
        <span class="title-en">/Settlement Price</span>
      </div>
      <!--筛选部分start-->

      <!--筛选部分end-->

      <div class="product-main-line"></div>

      <!--产品列表start-->
      <div class="product-main-list">
        <el-tabs v-model="activeName">
          <el-tab-pane v-for="item in priceConfig" :label="item.label" :name="item.id" :key="item.id">
            <el-table :data="item.data" max-height="700px" style="width: 100%" stripe>
              <el-table-column width="20"> </el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="item.label == '小智产品模块' ? '按年结算价格' : '按年市场价格'">
                <template slot-scope="scope">
                  <span>{{item.label == '小智产品模块'?scope.row.price_info.price:scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="item.label == '小智产品模块' ? '买断结算价格' : '按年结算价格'">
                <template slot-scope="scope">
                  <span>{{item.label == '小智产品模块'? scope.row.price_info.buyout_price:scope.row.buyout_price }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="安捷云 公有云产品模块" name="afapps">
            <el-table :data="afTableData" max-height="700px" style="width: 100%" stripe>
              <el-table-column width="20"> </el-table-column>
              <el-table-column label="应用名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="按年市场价格">
                <template slot-scope="scope">
                  <span>{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column label="按年结算价格">
                <template slot-scope="scope">
                  <span>{{ scope.row.buyout_price }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>


    </div>
  </div>
</template>

<script>
import { createGetUrlParams } from "@/utils/url";
// import { payVerify } from "@/utils/pay";
// import { checkAgentPrice } from "@/api/agent";
import { check_price } from "@/api/user";
import { getAFCloudApps } from '@/api/afCloud';
export default {
  data() {
    return {
      activeName: "editions",
      priceConfig: {
        editions: { id: "editions", label: "FastBI产品版本", data: [] },
        modules: { id: "modules", label: "FastBI产品模块", data: [] },
        suits: { id: "suits", label: "FastBI应用模块", data: [] },
        xzreports: { id: "xzreports", label: "小智产品模块", data: [] },
      },
      loading: false,
      verifyCodeResult: {
        //接收效验code是否已存在结果
        success: false,
        loading: false,
        icon: "",
      },
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      module: [], //模块
      codeLoading: false,
      curentId: 0, //选中表格行的id
      currentIndex: 0, //选中表格行的元素下标
      payTableShow: false,
      payTableData: [], //支付所需价格表
      payData: "", //需要支付的数据
      payBtnShow: false,
      alertType: "success",
      payDescription: "",
      /*筛选条件*/
      searchOption: {
        openingDateStart: "", //选择开通时间-开始
        openingDateEnd: "", //选择开通时间-结束
        expirationDateStart: "", //选择过期时间-开始
        expirationDateEnd: "", //选择过期时间-结束
        customerName: "", //选择授权客户
        code: "", //选择授权码
      },

      /*开通时间start*/
      pickerOptions1: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近1年",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      /*开通时间end*/

      /*过期时间start*/
      pickerOptions3: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },

      /*过期时间end*/

      /*表格数据start*/
      tableData: [],
      /*表格数据end*/

      formLabelWidth: "125px",
      afTableData: []
    };
  },
  mounted() {
    this.getModuleAuthData();
    // this.getModuleData();
  },
  methods: {
    // getPayType(val) {
    //   return payType[val];
    // },


    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    getDiscountPrice(price, discount) {
      if (price <= 0) {
        return 0
      } else {
        const result = price * discount;
        return parseFloat(result.toFixed(2))
      }
    },
    async getModuleAuthData() {
      //获取模块用户列表
      // console.log(this.$store);
      this.loading = true;

      // 
      await check_price()
        .then((res) => {
          const fbi_discount = res.fbi_discount
          for (const key in res) {
            let data = res[key];

            if (key in this.priceConfig) {
              if (key == "xzreports") {
                this.priceConfig[key].data = data.filter((item, index) => {
                  let price_info = item.price_info
                  if (price_info && (price_info.valid || price_info.buyout_valid)) {
                    // return item;
                    if (!price_info.price || !price_info.valid) {
                      price_info.price = "-----"
                    }
                    if (!price_info.buyout_price || !price_info.buyout_valid) {
                      price_info.buyout_price = "-----"
                    }

                    return item
                  }
                });
              } else {
                this.priceConfig[key].data = data.filter((item, index) => {
                  let price = item.price
                  let price_info = item.price_info
                  if (price_info && (price_info.valid || price_info.buyout_valid)) {
                    if (price) {
                      item.buyout_price = this.getDiscountPrice(price, fbi_discount)
                    } else {
                      item.price = "-----"
                      item.buyout_price = "-----"
                    }
                    return item
                  }

                });
              }

            }

          }


          console.log(this.tableData);
        })
        .catch(() => {
        });

      this.$store.dispatch('user/userinfo').then(() => {
        let discount = 1;
        let data = []
        if (this.$store.getters.userInfo.finance && this.$store.getters.userInfo.finance.p_afmodule_discount) {
          discount = this.$store.getters.userInfo.finance.p_afmodule_discount;
        }
        console.log(this.$store.getters.userInfo.finance, 'this.$store.getters.userInfo.finance')
        getAFCloudApps().then(res => {
          this.loading = false;
          res.map(item => {
            if (Array.isArray(item.versions)) {
              for (const v of item.versions) {
                data.push({
                  name: `${item.name} ${v.name}`,
                  price: v.price,
                  buyout_price: this.getDiscountPrice(v.price, discount)
                })
              }
            }
            this.afTableData = data
          })
        }).catch(err => {
          this.loading = false;
        })


      }).catch(err => {
        this.loading = false;
      })



    },
  },
};
</script>

<style lang="scss">
@import url("../../assets/css/product.css");

.service {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector {
      width: 100%;
      //height: 37px !important;
      background: #fff;

      .selector-center {
        margin-left: 0 !important;
        width: 400px !important;
      }
    }

    .group {
      p {
        margin: 10px 15px 10px 5px !important;
        float: left !important;
        width: 50px !important;
        height: 32px !important;
        line-height: 32px !important;
        text-align: right !important;
      }
    }

    .group .el-input {
      float: left !important;
      margin: 10px 0px !important;
      width: 120px !important;
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }

    .selector-right {
      height: 100% !important;
      line-height: 50px !important;
    }
  }

  .alert {
    margin-bottom: 10px;
  }

  .pay_btn {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial/settlement.vue